import { simplePath } from "../../utils.js";
const POST_RESEND_VERIFICATION_EMAIL = '/v2/user/resend-verification-email';
function resend_verification_email_path() {
    return simplePath(POST_RESEND_VERIFICATION_EMAIL, {});
}
export { POST_RESEND_VERIFICATION_EMAIL, resend_verification_email_path };
